import { Component, inject, effect, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AVAILABLE_LANGUAGES, I18nService } from './shared/i18n/i18n.service';
import { ThemeService } from './shared/services/theme.service';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  public readonly i18n = inject(I18nService);
  private readonly themeService = inject(ThemeService);

  constructor() {
    effect(() => {
      document.body.classList.toggle(
        'dark-theme',
        this.themeService.isDarkMode(),
      );
    });
  }

  ngOnInit() {
    this.i18n.lang.set(AVAILABLE_LANGUAGES.EN);
  }
}
